/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Status_Requesting_ReviewInputs */



/**
* | output |
* | --- |
* | "Requesting review" |
*
* @param {Iconik_Publish_Status_Requesting_ReviewInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_status_requesting_review = /** @type {((inputs?: Iconik_Publish_Status_Requesting_ReviewInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Status_Requesting_ReviewInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Requesting review")
	if (locale === "de") return /** @type {LocalizedString} */ ("Requesting review")
	if (locale === "it") return /** @type {LocalizedString} */ ("Requesting review")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Requesting review")
	if (locale === "es") return /** @type {LocalizedString} */ ("Requesting review")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Requesting review")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Requesting review")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Requesting review")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Requesting review")
	return /** @type {LocalizedString} */ ("Requesting review")
});